import React from 'react'
import AddSalary from '../../../../components/People/Salaries/AddSalary/AddSalary'
import { withRouter } from 'react-router-dom'
import { get, isEmpty, pick } from 'lodash'

import useFetchObject from '../../../../elements/Hooks/useFetchObject'
import { SalariesApi } from '../../../../api/People/Salaries'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import { message } from 'antd'
import useSubmit from '../../../../elements/Hooks/useSubmit'
import DocumentsApi from '../../../../api/Documents'
import useTitle from '../../../../elements/Hooks/useTitle'

const api = SalariesApi
const docsApi = new DocumentsApi()
const formRef = React.createRef()
AddSalaryCont.propTypes = {}

function AddSalaryCont (props) {
  const key = get(props.match, 'params.key')
  const type = key ? 'edit' : 'new'

  const { fetch, fetching, object: salary, setObject: setSalary } = useFetchObject(
    () => api.get(key),
    false,
    [key],
    isEmpty(key),
  )
  const { list: actions, fetching: fetchingActions, fetch: fetchActions } = useFetchList(
    () => docsApi.actions('salaries', salary.status),
    [salary.status, isEmpty(salary.status)],
  )

  const [submittingOperation, submitOperation] = useSubmit(SalariesApi.operation)
  const [updating, updateFunc] = useSubmit(api.update)

  function checkForm () {
    return new Promise((res, rej) => {
      formRef.current.validateFieldsAndScroll((err, values) => {
        if (!err) {
          res(values)
        } else rej(err)
      })
    })
  }

  const [submitting, submitFunc] = useSubmit(api.create)

  async function submit () {
    const values = await checkForm()
    const submitted = await submitFunc(values)
    if (submitted)
      props.history.push({
        pathname: `/people/salaries/${submitted._key}/update`,
      })
  }

  async function update () {
    const values = await checkForm()
    const salaryDB = await updateFunc({
      ...pick(salary, ['_key', '_id', '_rev']),
      ...values,
    })
    if (salaryDB) setSalary(salaryDB)
  }

  const [removing, removeFunc] = useSubmit(api.remove)

  async function handleActions (operation) {
    let hide = message.loading('', 0)
    switch (operation) {
      case 'remove':
        const removed = await removeFunc({
          ...pick(salary, ['_key', '_rev', '_id']),
        })
        if (removed)
          props.history.replace({
            pathname: `/people/salaries/`,
          })
        break
      default:
        const ObjectDB = await submitOperation({
          status: operation,
          ...pick(salary, ['_key', '_rev', '_id']),
        })
        if (ObjectDB) setSalary(ObjectDB)
    }
    hide()
  }

  async function onHold () {
    let hide = message.loading('', 0)

    let newPaymentStatus = salary.paymentStatus

    if (salary.paymentStatus === 'New') {
      newPaymentStatus = 'Hold'
    }

    if (salary.paymentStatus === 'Hold') {
      newPaymentStatus = 'New'
    }

    try {
      await SalariesApi.update({
        paymentStatus: newPaymentStatus,
        ...pick(salary, ['_id', '_key', '_rev']),
      })
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    hide()

    fetch()
  }

  useTitle(salary.code === undefined ? `Create New Salary` : `${salary.code} Salary`)

  return (
    <AddSalary
      {...{
        key,
        type,
        fetch,
        fetching,
        salary,
        actions,
        fetchingActions,
        fetchActions,
        setSalary,
        //
        submitting,
        updating,
        submit,
        removing,
        update,
        formRef,
        handleActions,
        onHold,
      }}
    />
  )
}

export default withRouter(AddSalaryCont)
